const villa_sec2Object = (payload) => {
  return {
    type: "villasec2",
    payload,
  };
};

export default villa_sec2Object;
